var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrammar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grammar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.76738 13.2083H11.509L7.25072 2.375H5.70072L1.44238 13.2083H3.18405L4.11738 10.7083H8.81738L9.76738 13.2083ZM4.75072 9.04167L6.47572 4.44167L8.20072 9.04167H4.75072ZM17.384 9.53333L10.6424 16.275L7.58405 13.2083L6.40905 14.3833L10.6507 18.625L18.559 10.7083L17.384 9.53333Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/grammar.b312939be9e30d6b8c9f8c05165488b5.svg";
export { ForwardRef as ReactComponent };